import type { CurrencyDto } from '@shared/api/contracts';

const normalizeAssetCode = (value: string): string => value.trim().toUpperCase();

/** Иконка актива из GET /app/v1/meta/currencies (как в инвойсах). */
export const buildCurrencyIconMap = (currencies: CurrencyDto[] | null | undefined): Map<string, string> => {
  const map = new Map<string, string>();
  if (!Array.isArray(currencies)) return map;
  for (const currency of currencies) {
    if (!currency.icon_base) continue;
    const keys = [currency.short_code, currency.code, currency.symbol].filter(Boolean) as string[];
    for (const key of keys) {
      map.set(normalizeAssetCode(key), currency.icon_base);
    }
  }
  return map;
};

export const resolveCurrencyIconSrc = (
  iconMap: Map<string, string>,
  assetCode: string,
): string | undefined => iconMap.get(normalizeAssetCode(assetCode));
